module.exports = __webpack_public_path__ + "img/4.077f9f56.png";